import { render, staticRenderFns } from "./NotificationsBell.vue?vue&type=template&id=e8d7afa8&scoped=true&"
import script from "./NotificationsBell.vue?vue&type=script&lang=js&"
export * from "./NotificationsBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsBell.vue?vue&type=style&index=0&id=e8d7afa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d7afa8",
  null
  
)

export default component.exports